import { API_BASEURL } from "@/constant"
import store from "@/store"
import { message } from "antd"
import axios from "axios"

// 1.创建类的实例对象
const instance = axios.create({})

// 2.设置api的根路径
switch (process.env.NODE_ENV) {
	case "development":
	case "production":
		instance.defaults.baseURL = API_BASEURL
		break
	default:
		break
}

// 3.当前请求为跨域类型时是否在请求中协带cookie。
instance.defaults.withCredentials = true

// 4.导出方法。config参数用于传递methods和params与data
async function download(method, url, data, config) {
	const queryArgs = {
		method,
		url,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json; charset=utf-8",
			withCredentials: true,
			Token: store.getState().token,
		},
		responseType: "blob",
		...config,
	}
	method === 'GET' ? queryArgs.params = data : queryArgs.data = data
	message.info("下载中，请等待~")

	try {
		let d = await instance.request(queryArgs)
		if (!d) {
			return false
		}
		if(!(d?.data?.type === "application/octet-stream")) {
			message.error("非application/octet-stream格式")
			return false
		}
		convertRes2File(d)
		return d
	} catch(err) {
		if(err?.response?.status) {
			message.error("下载异常，状态码：" + err.response.status)
		} else {
			message.error("下载异常")
		}
	}
}

export default download

// 将返回内容转为文件
function convertRes2File(response) {
	// 提取文件名
	const fileName = response.headers["content-disposition"].match(/filename=(.*)/)[1]
	// 将二进制流转为blob
	const blob = new Blob([response.data], { type: "application/octet-stream" })
	if (typeof window.navigator.msSaveBlob !== "undefined") {
		// 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
		window.navigator.msSaveBlob(blob, decodeURI(fileName))
	} else {
		// 创建新的URL并指向File对象或者Blob对象的地址
		const blobURL = window.URL.createObjectURL(blob)
		// 创建a标签，用于跳转至下载链接
		const tempLink = document.createElement("a")
		tempLink.style.display = "none"
		tempLink.href = blobURL
		tempLink.setAttribute("download", decodeURI(fileName))
		// 兼容：某些浏览器不支持HTML5的download属性
		if (typeof tempLink.download === "undefined") {
			tempLink.setAttribute("target", "_blank")
		}
		// 挂载a标签
		document.body.appendChild(tempLink)
		tempLink.click()
		document.body.removeChild(tempLink)
		// 释放blob URL地址
		window.URL.revokeObjectURL(blobURL)
	}
}
